import React from "react";
//Page Components
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import DescriptionSection from "../components/DescriptionSection";
//Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import { Hide } from "../styles";

const AboutUs = () => {
  return (
    <motion.div
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <AboutSection />
      <Hide>
      <ServicesSection />
      </Hide>
      <DescriptionSection/>
    </motion.div>
  );
};

export default AboutUs;
